import {
  Message,
  MessageCreate,
  MessageUpdate,
  MessageSendResponse,
} from "@cnx/common";
import api from "services/api";

class MessageService {
  static fetchAllMessages = async (): Promise<Message[]> => {
    const { data } = await api.get<Message[]>("/messages");
    return data;
  };

  static fetchMessagesByDiscussionId = async ({
    discussionId,
  }: {
    discussionId?: string;
  }): Promise<Message[]> => {
    const { data } = await api.get<Message[]>(
      `/messages?discussionId=${discussionId}`
    );

    return data.map(message => ({
      ...message,
      attachments: message.attachments?.map(att => {
        if (att.attachmentBase64) {
          const binary = atob(att.attachmentBase64);
          const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
          return {
            ...att,
            attachmentBlob: new Blob([bytes], {
              type: att.attachmentMimeType ?? "application/octet-stream",
            }),
          };
        }

        return att;
      }),
    }));
  };

  static addMessage = async (body: MessageCreate, attachments: Blob[]) => {
    const newFormData = new FormData();
    newFormData.append("messageTypeKey", body.messageTypeKey);
    if (body.discussionId) {
      newFormData.append("discussionId", body.discussionId);
    }
    if (body.context) {
      newFormData.append("context", body.context);
    }
    if (body.contextId) {
      newFormData.append("contextId", body.contextId);
    }
    if (body.pinned) {
      newFormData.append("pinned", String(body.pinned));
    }
    if (body.message) {
      newFormData.append("message", body.message);
    }

    attachments.forEach(attachment => {
      newFormData.append("attachments", attachment);
    });

    return api.post<MessageSendResponse>("/messages", newFormData);
  };

  static editMessage = async (body: MessageUpdate, id: string) => {
    return api.put(`/messages/${id}`, body);
  };

  static deleteMessage = async (id: string) => {
    return api.delete(`/messages/${id}`);
  };

  static deleteMessages = async (ids: string[]) => {
    return api.delete("/messages/bulk", { data: { ids } });
  };

  static markMessageAsRead = async (messageId: string) => {
    return api.put("/messages/read", { messageId });
  };
}

export default MessageService;
